import React, { HTMLAttributes } from 'react';
import { useStoreState } from '@/store';
import { SHAPE_ENUM, SVG_ATTR_ENUM } from '../../types';
import Position from '../position';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    style?: React.CSSProperties;
    OnClick: (type: SVG_ATTR_ENUM, val: number) => void;
}
const Ellipse: React.FC<IProps> = (props) => {
    const { style, OnClick } = props;
    const svgInfo = useStoreState((state) => state.svgModel.svgConfig);
    const curShape = useStoreState((state) => state.svgModel.curShape);
    return (
        <React.Fragment>
            {curShape === SHAPE_ENUM.ELLIPSE ? (
                <div className="design-svg-panel-circle" style={style}>
                    {/* <Position
                        title="CX(水平圆心点)"
                        type={SVG_ATTR_ENUM.CX}
                        pos={svgInfo[curShape].cx}
                        onClick={OnClick}
                    />
                    <Position
                        title="CY(垂直圆角)"
                        type={SVG_ATTR_ENUM.CY}
                        pos={svgInfo[curShape].cy}
                        onClick={OnClick}
                    /> */}
                    <Position
                        title="RX (水平半径)"
                        type={SVG_ATTR_ENUM.RX}
                        pos={svgInfo[curShape].rx}
                        onClick={OnClick}
                    />
                    <Position
                        title="RY (垂直半径)"
                        type={SVG_ATTR_ENUM.RY}
                        pos={svgInfo[curShape].ry}
                        onClick={OnClick}
                    />
                </div>
            ) : null}
        </React.Fragment>
    );
};
export default React.memo(Ellipse);
